import { useEffect, useState } from "react";
import { api, fmtDate, fmtMoney } from "@/lib/api";
import { PageHeader, Card, StatusBadge } from "@/pages/AppLayout";

const LABEL = { paid: "Pagado", pending: "Pendiente", expired: "Expirado", failed: "Fallido", refunded: "Reembolsado" };

export default function Billing() {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/billing/transactions").then((r) => setRows(r.data)); }, []);
  return (
    <div data-testid="billing-page">
      <PageHeader eyebrow="Facturación" title="Facturación" subtitle="Historial de pagos procesados con Stripe. Los recibos llegan al correo usado en el pago." />
      <Card className="p-0 overflow-x-auto">
        <table className="w-full text-sm" data-testid="billing-table">
          <thead><tr className="text-left text-xs uppercase tracking-wider text-slate-500 border-b border-[#222B40]">
            <th className="p-4">Fecha</th><th className="p-4">Concepto</th><th className="p-4">Estado</th><th className="p-4 text-right">Importe</th>
          </tr></thead>
          <tbody>
            {rows?.length === 0 && <tr><td colSpan={4} className="p-8 text-center text-slate-500" data-testid="billing-empty">Todavía no hay pagos.</td></tr>}
            {rows?.map((r) => (
              <tr key={r.session_id} data-testid={`billing-row-${r.session_id}`} className="border-b border-[#222B40]/60 last:border-0">
                <td className="p-4 text-slate-400 whitespace-nowrap">{fmtDate(r.created_at)}</td>
                <td className="p-4 text-slate-200">{{ plan: "Suscripción", renovacion: "Renovación", pack: "Paquete de créditos" }[r.kind]} <span className="text-xs text-slate-500">{r.item_name} · {r.provider}{r.coupon ? ` · cupón ${r.coupon}` : ""}</span></td>
                <td className="p-4"><StatusBadge ok={r.payment_status === "paid"}>{LABEL[r.payment_status] || r.payment_status}</StatusBadge></td>
                <td className="p-4 text-right font-mono text-slate-200">{fmtMoney(r.amount, r.currency)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
